import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { CtAdminUserList } from 'containers';
import { AdminUserMenu, AdminPageTitle, AdminPageTemplate } from 'components';

class CtAdminUser extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <AdminPageTemplate className="table">
        <AdminPageTitle
          type="table"
          title={defineMessages(formatMessage({ id: 'CtAdminUser_1', defaultMessage: '사용자' }))}>
          <AdminUserMenu />
        </AdminPageTitle>
        <CtAdminUserList />
      </AdminPageTemplate>
    );
  }
}

CtAdminUser.propTypes = {};
CtAdminUser.defaultProps = {};

export default injectIntl(CtAdminUser);



// WEBPACK FOOTER //
// ./src/script/containers/admin/user/CtAdminUser.js